import axiosInstance from './axiosInstance'

export const getBonusMetrics = () => {
  return axiosInstance.get('/dashboard/bonus-metrics')
}

export const getSalesMetrics = () => {
  return axiosInstance.get('/dashboard/sales-metrics')
}

export const getSalesMetricsByUserId = (userId) => {
  return axiosInstance.get(`dashboard/sales-metrics-by-user-id/${userId}`)
}

export const getSalesMetricsByUsers = () => {
  return axiosInstance.get('/dashboard/sales-metrics-by-users')
}

export const getRevenueRecordings = (year, month) => {
  return axiosInstance.get(`/dashboard/revenue-recordings?year=${year}&month=${month}`)
}
